import { Http } from "@/plugins/http";

export class DocumentsService {
  /**
   * Возвращает модель документа
   * @return Promise<any>
   */
  static getById(id) {
    return Http.get(`v1/documents/${id}`, { params: { lang: "ru" } }).then(response => response.data.data);
  }

  /**
   * Возвращает типы/категории документов
   * @return Promise<any, DocumentTypeItem[]>
   */
  static getTypes() {
    return Http.get(`v1/documents/types`, { params: { lang: "ru" } }).then(response => response.data.data);
  }
}
